import type { ReservationWrapper } from "@b2bportal/core-types";
import {
  type Airline,
  type Airport,
  type GetPackageItineraryRequest,
  type GetPackageItineraryResponse,
  type PackageItinerarySummary,
  rbcBundledPackagesApi,
} from "@b2bportal/rbc-bundled-packages-api";
import { axiosInstance } from "@hopper-b2b/api";
import { handleAxiosError } from "@overrides/utilities";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { transformPackageItineraries } from "./transformPackageItineraries";

export const packagesPostBookingApi = createApi({
  reducerPath: "packagesPostBookingApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["PackageReservationList"],
  endpoints: (builder) => ({
    fetchAllPackageReservations: builder.query<
      {
        current: ReservationWrapper<PackageItinerarySummary>[];
        past: ReservationWrapper<PackageItinerarySummary>[];
        context: {
          airports: { [key: string]: Airport };
          airlines: { [key: string]: Airline };
        };
      },
      void
    >({
      queryFn: async () => {
        try {
          const response =
            await rbcBundledPackagesApi(
              axiosInstance
            ).apiV0PackagesItinerariesPost();

          const itineraries = response.data.itineraries ?? {};
          const { current, past } = transformPackageItineraries(
            itineraries as Record<string, PackageItinerarySummary[]>
          );

          return {
            data: {
              current,
              past,
              context: response.data.context,
            },
          };
        } catch (error) {
          return handleAxiosError(error);
        }
      },
      providesTags: ["PackageReservationList"],
    }),
    fetchPackageReservation: builder.query<
      GetPackageItineraryResponse,
      GetPackageItineraryRequest
    >({
      queryFn: async (request) => {
        try {
          const response =
            await rbcBundledPackagesApi(
              axiosInstance
            ).apiV0PackagesItineraryPost(request);
          return { data: response.data };
        } catch (error) {
          return handleAxiosError(error);
        }
      },
    }),
  }),
});

export const {
  useFetchAllPackageReservationsQuery,
  useFetchPackageReservationQuery,
} = packagesPostBookingApi;
